import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes } from "react-router-dom";
// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import axios from "axios";
import { SnackbarProvider } from "notistack";
import React, { Suspense, lazy } from "react";
import { Route } from "react-router-dom";
import { AppProvider } from "./AppContext";
import AppInitializer from "./AppInitializer";
import LoginProtected from "./components/LoginProtected";
import { MasterPasswordProvider } from "./components/MasterPasswordDialog/MasterPasswordContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Spinner from "./components/Spinner";
import ScrollToTop from "./components/scroll-to-top";
import appConfig from "./config";
import "./i18n/i18n";
import { LocalizationProvider } from "./i18n/LocalizationProvider";
import { PosProvider } from "./shared/PosContext";
import DisablePullToRefresh from "./utils/DisablePullToRefresh";

// import LoginPage from "./pages/LoginPage";
const LoginPage = lazy(() => import("./pages/Login"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: true,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            cacheTime: 0,
            // enabled: !!localStorage.getItem("accessToken"),
        },
    },
});

axios.interceptors.request.use(
    (config) => {
        config.withCredentials = true;
        config.crossDomain = true;
        config.baseURL = appConfig.apiBaseUrl;

        let token = localStorage.getItem("accessToken");

        if (token) {
            // config.headers["Authorization"] = `${token}`;
        }
        config.headers["Content-Type"] = "application/json";
        config.headers["Access-Control-Allow-Credentials"] = true;
        config.headers["Accept"] = "application/json";

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

const persister = createSyncStoragePersister({
    storage: window.localStorage,
});

// persistQueryClient({
//     queryClient,
//     persister: persister,
// });

export default function App() {
    // Status useState for store user loggedIn and did user logout

    // const [status, setStatus] = useState(() => {
    //     const token = localStorage.getItem("token");
    //     if (!token) {
    //         return { loggedIn: false, didLogout: false };
    //     } else {
    //         return { loggedIn: true, didLogout: false };
    //     }
    // });

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <DisablePullToRefresh />
                <HelmetProvider>
                    <BrowserRouter>
                        <SnackbarProvider maxSnack={5}>
                            <LocalizationProvider>
                                <ThemeProvider>
                                    <ScrollToTop />
                                    <Routes>
                                        {/*Login Page */}
                                        <Route
                                            path="/login"
                                            element={
                                                <Suspense fallback={<Spinner />}>
                                                    <LoginProtected>
                                                        <LoginPage />
                                                    </LoginProtected>
                                                </Suspense>
                                            }
                                        />
                                        <Route
                                            path="*"
                                            element={
                                                <ProtectedRoute>
                                                    <AppProvider>
                                                        <MasterPasswordProvider>
                                                            <PosProvider>
                                                                <AppInitializer>
                                                                    <Router />
                                                                </AppInitializer>
                                                            </PosProvider>
                                                        </MasterPasswordProvider>
                                                    </AppProvider>
                                                </ProtectedRoute>
                                            }
                                        />
                                    </Routes>
                                </ThemeProvider>
                            </LocalizationProvider>
                        </SnackbarProvider>
                    </BrowserRouter>
                </HelmetProvider>
                {/* <ReactQueryDevtools initialIsOpen={false} position='bottom-right' /> */}
            </QueryClientProvider>
        </>
    );
}
